import React, { Component } from 'react';
import _PageHeader_User_Wrapper from 'containers/Page/Header/_components/User/_styles/_PageHeader_User_Wrapper';
import _Page_Header_User_Guest from 'containers/Page/Header/_components/User/_Page_Header_User_Guest';
import appPersonContextConnector from 'context/AppPersonContext/appPersonContextConnector';
import _Page_Header_User_Menu from 'containers/Page/Header/_components/User/_Page_Header_User_Menu';


@appPersonContextConnector(['user', 'self', 'is_guest'])
export default class _Page_Header_User extends Component {

  render () {
    const {
      props: {
        is_guest,
        react_widget,
      },
    } = this;

    return (
      <_PageHeader_User_Wrapper>
        {is_guest && <_Page_Header_User_Guest react_widget={react_widget} />}
        {!is_guest && <_Page_Header_User_Menu user={this.props.user} self={this.props.self} react_widget={react_widget} />}
      </_PageHeader_User_Wrapper>
    );
  }
}
